import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navigation />
      
      <section className="py-16 px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
          
          <div className="bg-white rounded-2xl border-2 border-slate-200 shadow-sm p-8 space-y-6 text-slate-700">
            <p className="text-sm text-slate-500">Last updated: December 2025</p>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Acceptance of Terms</h2>
              <p>
                By accessing and using Learn with Zeenat, you accept and agree to be bound by these Terms of Service. 
                If you do not agree to these terms, please do not use our platform.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Use of Services</h2>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Permitted Use</h3>
              <p className="mb-4">You may use our platform to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Access and download educational resources</li>
                <li>Generate AI-powered teaching materials</li>
                <li>Create lesson plans and assessments</li>
                <li>Use resources for your own teaching purposes</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-slate-900 mb-2 mt-4">Prohibited Use</h3>
              <p className="mb-4">You may NOT:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Redistribute or resell our resources</li>
                <li>Share your account credentials with others</li>
                <li>Use the platform for commercial distribution</li>
                <li>Attempt to reverse engineer or hack the platform</li>
                <li>Upload harmful or inappropriate content</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Subscription Plans</h2>
              <p className="mb-4">
                We offer Free, Teacher Plus ($10/month), and Teacher Pro ($13/month) subscription tiers. 
                Each tier provides different features and AI generation limits as described on our pricing page.
              </p>
              <p className="mb-4">
                <strong>AI Generation Limits:</strong>
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Free: 5 generations per month</li>
                <li>Teacher Plus: 200 generations per month</li>
                <li>Teacher Pro: Unlimited generations</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Payment and Billing</h2>
              <p className="mb-4">
                Payments are processed securely and automatically through Razorpay, our trusted payment gateway. 
                We accept the following payment methods:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Credit/Debit Cards (Visa, MasterCard, American Express)</li>
                <li>UPI (India)</li>
                <li>Net Banking</li>
                <li>Digital Wallets</li>
              </ul>
              <p className="mt-4">
                Subscriptions activate immediately upon successful payment confirmation from Razorpay. 
                Subscriptions are billed monthly and renew automatically unless cancelled. 
                You can manage your subscription and payment methods from your account dashboard.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Intellectual Property</h2>
              <p>
                All content, resources, and materials on Learn with Zeenat are protected by copyright and intellectual property laws. 
                Resources are licensed for your personal teaching use only.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">AI-Generated Content</h2>
              <p>
                AI-generated materials are provided as educational tools. While we strive for accuracy, teachers should review 
                all AI-generated content before use in the classroom. We are not responsible for any errors in AI-generated materials.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Limitation of Liability</h2>
              <p>
                Learn with Zeenat is provided "as is" without warranties of any kind. We are not liable for any damages 
                arising from your use of the platform.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Termination</h2>
              <p>
                We reserve the right to terminate or suspend access to our platform for violations of these Terms of Service.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Changes to Terms</h2>
              <p>
                We may update these Terms of Service from time to time. Continued use of the platform after changes 
                constitutes acceptance of the updated terms.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Contact Us</h2>
              <p>
                For questions about these Terms of Service, contact us at:{' '}
                <a href="mailto:admin@learnwithzeenat.com" className="text-blue-600 hover:underline">
                  admin@learnwithzeenat.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default TermsOfService;
